export default "__VITE_ASSET__DQQNoQT8__"